import { render, staticRenderFns } from "./_columnWithOffset.vue?vue&type=template&id=4ffc35e3&scoped=true&"
import script from "./_columnWithOffset.vue?vue&type=script&lang=js&"
export * from "./_columnWithOffset.vue?vue&type=script&lang=js&"
import style0 from "./_columnWithOffset.vue?vue&type=style&index=0&id=4ffc35e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffc35e3",
  null
  
)

export default component.exports